import { render, staticRenderFns } from "./promo_tools.vue?vue&type=template&id=71bddc5d&scoped=true"
import script from "./promo_tools.vue?vue&type=script&lang=js"
export * from "./promo_tools.vue?vue&type=script&lang=js"
import style0 from "./promo_tools.vue?vue&type=style&index=0&id=71bddc5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bddc5d",
  null
  
)

export default component.exports